import ApiClient from './ApiClient';

class CampaignsAPI extends ApiClient {
  constructor() {
    super('campaigns', { accountScoped: true });
  }

  restore(id) {
    return window.axios.post(`${this.url}/${id}/restore`);
  }
}

export default new CampaignsAPI();
